import { MerchantCurrency } from 'components/MerchantCurrency';
import React, { FC, memo } from 'react';
import cx from 'clsx';

import { Card } from 'components/Card';
import { MENU_ITEM_TEST_ID } from '../const';

import styles from './styles.module.scss';
import { Item } from 'olo-service';
import { ImageSize, MenuItemImage } from 'components/MenuItemImage';
import { useTranslation } from 'react-i18next';
import { GIFTCARD_MENU_ITEM_ID } from 'components/MenuContext/MenuContext';

type MenuItemCardProps = React.HTMLAttributes<HTMLElement> & {
  item?: Item;
};

export const MenuItemCard: FC<MenuItemCardProps> = memo(function MenuItemCard({
  item, className, onClick, children, ...props
}) {
  const { t } = useTranslation();
  if (!item) return null;

  const { id, name, description, price, available, pricePlaceholder = '' } = item;
  const isGiftCardItem = (id === GIFTCARD_MENU_ITEM_ID);

  return (
    <Card id={id} className={cx(styles.card, className)} linkTo={id} {...props}>
      <div className={cx(available ? styles.availableItem : styles.unAvailableItem, className)}></div>
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={cx(styles.title, 'h4')}>{name}</h3>
          { available && isGiftCardItem && <p className={styles.rightElement} data-testid={MENU_ITEM_TEST_ID.giftCard}>{pricePlaceholder}</p>}
          { available && !isGiftCardItem && <MerchantCurrency tagName="p" className={styles.rightElement} data-testid={MENU_ITEM_TEST_ID.price} amount={price} placeholder={pricePlaceholder} /> }
          { !available && <p className={cx(!available ? styles.unAvailableItemText : '', className)} data-testid={MENU_ITEM_TEST_ID.unavailable}>{t('cart.unavailable')}</p> }
        </div>
        {description && <div className={styles.description}>
          {description}
        </div>}
        {children}
      </div>
      <MenuItemImage item={item} imageSize={ImageSize.SMALL} data-testid={MENU_ITEM_TEST_ID.price} />
    </Card>
  );
});
